import { ArrowButton, NumberButton } from './Buttons'
import styles from './Pagination.module.css'
import usePagesRange from './usePagesRange'

type PaginationProps = {
  onPageChange: (page: number) => void
  totalPages: number
  currentPage: number
  compactVersion?: boolean
}

const Pagination = ({ onPageChange, totalPages, currentPage, compactVersion = false }: PaginationProps) => {
  const { pages } = usePagesRange(currentPage, totalPages, compactVersion)

  return (
    <div className={styles.container}>
      {/* Left arrow */}
      <ArrowButton direction="left" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 0} />

      {/* Numbers */}
      {pages.map((page, index) => {
        const isCurrent = currentPage === page
        if (page === -1) {
          return (
            <span key={`${page}-${index}`} className={styles.dots}>
              ...
            </span>
          )
        }
        return (
          <NumberButton key={`${page}-${index}`} disabled={isCurrent} onClick={() => onPageChange(page)}>
            <span style={{ fontSize: 14 }}>{page + 1}</span>
          </NumberButton>
        )
      })}

      {/* Right arrow */}
      <ArrowButton
        direction="right"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages - 1}
      />
    </div>
  )
}

export default Pagination
